interface FreeTextInputProps {
  value: string;
  onChange: (s: string) => void;
  placeholder?: string;
  /** Hard cap. Defaults to 500. */
  maxLength?: number;
  /** Hide the char counter (for very small inputs like salary). */
  hideCounter?: boolean;
  /** Render as single-line input (currency, salary, etc.). */
  singleLine?: boolean;
  /** Optional left-side adornment (e.g. "$" for salary). */
  prefix?: string;
  /** numeric keyboard on mobile */
  numeric?: boolean;
}

export function FreeTextInput({
  value,
  onChange,
  placeholder,
  maxLength = 500,
  hideCounter = false,
  singleLine = false,
  prefix,
  numeric = false,
}: FreeTextInputProps) {
  const inputClass =
    'w-full rounded-2xl border border-ink-light/40 bg-white px-5 py-4 text-base outline-none focus:border-brand focus:ring-2 focus:ring-brand-100';

  return (
    <div>
      <div className={prefix ? 'relative' : ''}>
        {prefix && (
          <span className="absolute left-5 top-1/2 -translate-y-1/2 text-ink-soft text-base">
            {prefix}
          </span>
        )}
        {singleLine ? (
          <input
            type="text"
            inputMode={numeric ? 'numeric' : 'text'}
            value={value}
            onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
            placeholder={placeholder}
            className={prefix ? `${inputClass} pl-9` : inputClass}
          />
        ) : (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
            placeholder={placeholder}
            rows={4}
            className={`${inputClass} resize-none`}
          />
        )}
      </div>
      {!hideCounter && !singleLine && (
        <p className="mt-2 text-xs text-ink-light text-right tabular-nums">
          {value.length} / {maxLength}
        </p>
      )}
    </div>
  );
}
